import { render, staticRenderFns } from "./restaurantMenuDetails.vue?vue&type=template&id=74234b6b&"
import script from "./restaurantMenuDetails.vue?vue&type=script&lang=js&"
export * from "./restaurantMenuDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports